import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

interface IProps {
  error: any
}

const Error = ({ error }: IProps) => (
  <Grid container direction="column">
    <Grid container item direction="column">
      <Grid item>
        <Box my={{ xs: 1 }}>
          <Typography variant="h4" color="error">
            Unable To Submit Order
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box my={{ xs: 1 }}>
          <Typography variant="h4" color="error">
            Error: {error.code}
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box my={{ xs: 1 }}>
          <Typography variant="h4" color="error">
            {error.message}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Grid>
)

export default React.memo(Error)
